
import { APICore } from "./apiCore";

const api = new APICore();
function fetchStatus(title:string) {
    const baseUrl = `/application/metadata`;
    return api.get(`${baseUrl}`,{title});
  }

  export {fetchStatus};